import { InjectionToken } from '@angular/core';

export interface PostHogConfig {
  apiKey?: string;
  apiHost?: string;
  personProfiles?: boolean;
  disableWebExperiments?: boolean;
  autocapture?: boolean;
  capturePageview?: boolean;
  capturePageleave?: boolean;
  debug?: boolean;
}

export const POSTHOG_CONFIG = new InjectionToken<PostHogConfig>(
  'POSTHOG_CONFIG'
);
